import React, { useState, useRef } from "react";
import "../Contracting/Contracting.css";
import logoSrc from "../img/logo.png";
import ContactForm from "../ContactForm"; // Make sure this component has the `openForm` method.

function SalesAgentFormular() {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };

  const [formData, setFormData] = useState({
    name: "",
    lastName: "",
    phone: "",
    address: "",
    email: "",
    experienceInSales: "",
    instagramProfile: "",
    twitterProfile: "",
    biography: "",
    budgetGoals: "",
    companyName: "",
    id: "", // This will be handled as a file input
  });

  const [snackbar, setSnackbar] = useState({
    message: "",
    show: false,
    type: "success",
  }); // Snackbar state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Create a FormData object to handle file uploads
    const formDataToSend = new FormData();

    // Append regular form data
    for (const key in formData) {
      formDataToSend.append(key, formData[key]);
    }

    // Append the file data
    const fileInput = document.querySelector('input[name="idFile"]');
    if (fileInput.files[0]) {
      formDataToSend.append("id", fileInput.files[0]);
    }

    // Send form data to the backend
    fetch("https://apiqms.shigjeta.com/api/forms/sales-agent/submit", {
      method: "POST",
      body: formDataToSend,
    })
      .then((response) => {
        if (response.ok) {
          console.log("Form data saved successfully");
          setSnackbar({
            message: "Form Submitted Successfully!",
            show: true,
            type: "success",
          }); // Success snackbar
        } else {
          console.error("Error saving form data");
          setSnackbar({
            message: "Error saving form data. Please try again.",
            show: true,
            type: "error",
          }); // Error snackbar
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setSnackbar({
          message: "Error submitting the form. Please try again.",
          show: true,
          type: "error",
        }); // Error snackbar
      });
  };

  // Snackbar styling
  const snackbarStyle = {
    position: "fixed",
    top: "20px", // Move it to the top
    left: "50%", // Center horizontally
    transform: "translateX(-50%)", // Adjust to perfectly center
    backgroundColor: snackbar.type === "success" ? "#16a085" : "#e74c3c", // Green for success, red for error
    color: "white",
    padding: "15px 30px",
    borderRadius: "8px",
    fontSize: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    zIndex: 1001,
    animation: "fadeIn 0.5s ease-out",
  };

  const dismissButtonStyle = {
    background: "none",
    border: "none",
    color: "white",
    fontSize: "16px",
    cursor: "none",
    fontWeight: "bold",
    marginLeft: "15px", // Adds a gap between the text and the button
  };

  // Close snackbar after 5 seconds
  setTimeout(() => {
    if (snackbar.show) {
      setSnackbar({ ...snackbar, show: false });
    }
  }, 5000);

  return (
    <>
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Formular Logo" />}
      </div>

      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          <div className="banner-text">
            <h1 className="banner-title">Your First Step into the Vision.</h1>
            <p className="banner-description">
              Submit your contract details and start the process today.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>
          </div>
          <div className="shop-hero-background"></div>
        </div>
      </section>
      <div className="img-background">
        <img
          className="img"
          id="banner1-video"
          src="/img/Sales Thumbnail.png" // Ensure the correct path to the image
          autoPlay
          muted
          loop
          playsInline
          onError={(e) => console.error("Error loading video:", e)}
          alt="img"
        />
      </div>
      <h3 className="textForm">Shigjeta LLC - Sales Agent Application Form</h3>

      {/* Form Section */}
      <section className="contract-form-container">
        <form onSubmit={handleSubmit} className="contract-form">
          <div className="divFlexField">
            <div className="form-group">
              <label>First Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your first name"
                required
              />
            </div>
            <div className="form-group">
              <label>Last Name</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Enter your last name"
                required
              />
            </div>
          </div>

          <div className="divFlexField">
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="form-group">
              <label>Phone Number</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter your phone number"
              />
            </div>
          </div>

          <div className="divFlexField">
            <div className="form-group">
              <label>Company Name</label>
              <input
                type="text"
                id="companyName"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                placeholder="Enter your company name"
                required
              />
            </div>
            <div className="form-group">
              <label>Experience in Sales</label>
              <select
                id="experienceInSales"
                name="experienceInSales"
                value={formData.experienceInSales}
                onChange={handleChange}
              >
                <option value="None">None</option>
                <option value="1-2 years">1-2 years</option>
                <option value="Over 10k">Over 10k</option>
                <option value="Please advice">Please advise</option>
              </select>
            </div>
          </div>

          <div className="divFlexField">
            <div className="form-group">
              <label>Instagram Profile</label>
              <input
                type="text"
                id="instagram"
                name="instagramProfile"
                value={formData.instagramProfile}
                onChange={handleChange}
                placeholder="www.instagram.com/profile"
                required
              />
            </div>
            <div className="form-group">
              <label>Twitter Profile</label>
              <input
                type="text"
                id="twitter"
                name="twitterProfile"
                value={formData.twitterProfile}
                onChange={handleChange}
                placeholder="www.twitter.com/profile"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>Biography</label>
            <textarea
              id="biography"
              name="biography"
              value={formData.biography}
              onChange={handleChange}
              placeholder="Biography"
              required
            />
          </div>

          <div className="form-group">
            <label>Budget Goals</label>
            <select
              id="budgetGoals"
              name="budgetGoals"
              value={formData.budgetGoals}
              onChange={handleChange}
            >
              <option value="Less than 5k">Less than 5k</option>
              <option value="5k - 10k">5k - 10k</option>
              <option value="Over 10k">Over 10k</option>
              <option value="Please advise">Please advise</option>
            </select>
          </div>

          <div className="form-group">
            <label>ID or Passport</label>
            <input
              type="file"
              name="idFile"
              accept="image/jpeg, image/png, image/jpg"
            />
            <p className="importantText">
              Important! We need your personal identification to verify and know
              who we are working with and to make the contract.
            </p>
          </div>

          <button type="submit" className="submit-button">
            Submit Application
          </button>
        </form>
      </section>

      {/* Snackbar display */}
      {snackbar.show && (
        <div style={snackbarStyle}>
          <span>{snackbar.message}</span>
          <button
            onClick={() => setSnackbar({ ...snackbar, show: false })}
            style={dismissButtonStyle}
          >
            X
          </button>
        </div>
      )}

      <ContactForm ref={contactFormRef} />
    </>
  );
}

export default SalesAgentFormular;
